'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { AuthApi } from '@/api';
import { useAccessToken } from '@/hooks/useAccessToken';
import { useLoginUrlData } from '@/hooks/useLoginUrlData';
import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
import { KB_PAY_CUSTOM_SCHEME, KB_PAY_CUSTOM_SEARCH_PARAMS } from '../_utils/reserved-keywords';
export const KbAppController = () => {
  const $ = _c(18);
  const pathname = usePathname();
  const isKbWebview = useDeviceInfoStore(_temp);
  const {
    loginParams
  } = useLoginUrlData();
  let t0;
  if ($[0] !== loginParams) {
    t0 = new URLSearchParams(loginParams).get(KB_PAY_CUSTOM_SEARCH_PARAMS.KB_ID);
    $[0] = loginParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const kbId = t0;
  let t1;
  if ($[2] !== isKbWebview) {
    t1 = () => {
      if (!isKbWebview) {
        return;
      }
      const listeners = [];
      document.querySelectorAll("a").forEach(el => {
        const href = el.getAttribute("href");
        if (!href) {
          return;
        }
        if (!href.startsWith("https")) {
          return;
        }
        if (href.startsWith(location.origin)) {
          return;
        }
        const handler = e => {
          e.preventDefault();
          window.location.href = `${KB_PAY_CUSTOM_SCHEME.EXTERNAL_PREFIX}${href}`;
        };
        el.addEventListener("click", handler);
        listeners.push([el, handler]);
      });
      return () => {
        listeners.forEach(_temp2);
      };
    };
    $[2] = isKbWebview;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isKbWebview || $[5] !== pathname) {
    t2 = [isKbWebview, pathname];
    $[4] = isKbWebview;
    $[5] = pathname;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  const isLogin = useAuthStore(_temp3);
  const {
    accessToken,
    refreshToken
  } = useAccessToken();
  const isEnabledKbPayMemberCheck = !!(isLogin && accessToken && refreshToken && kbId);
  let t3;
  let t4;
  if ($[7] !== accessToken || $[8] !== isEnabledKbPayMemberCheck || $[9] !== kbId || $[10] !== refreshToken) {
    t3 = [WEBVIEW_TYPE.KB_PAY, kbId, accessToken, refreshToken, isEnabledKbPayMemberCheck];
    t4 = () => {
      if (!isEnabledKbPayMemberCheck) {
        return;
      }
      AuthApi["post:/wello/v2/auth/member/kb-member-check"]({
        body: {
          accessToken,
          refreshToken,
          externalMemberId: kbId
        }
      });
    };
    $[7] = accessToken;
    $[8] = isEnabledKbPayMemberCheck;
    $[9] = kbId;
    $[10] = refreshToken;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isEnabledKbPayMemberCheck || $[14] !== t3 || $[15] !== t4) {
    t5 = {
      enabled: isEnabledKbPayMemberCheck,
      queryKey: t3,
      queryFn: t4
    };
    $[13] = isEnabledKbPayMemberCheck;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  useQuery(t5);
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <></>;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
function _temp(state) {
  return state.webviewType === WEBVIEW_TYPE.KB_PAY;
}
function _temp2(t0) {
  const [el_0, handler_0] = t0;
  return el_0.removeEventListener("click", handler_0);
}
function _temp3(state_0) {
  return state_0.isLogin;
}